"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getContextType = exports.getTrafficType = void 0;
const ROUTE_ID_TRAFFIC_TYPE_MAP = {
    exsf01: 'paid',
    exsf01d: 'paid',
    awsem: 'paid',
    _experiment: 'paid',
    winback: 'paid',
    'include hm?': 'paid',
    'hm-paid': 'paid',
    'hm-exsf01': 'paid',
    'hm-exsf01d': 'paid',
    'hm-awsem': 'paid',
    'hm-winback': 'paid',
    'app-14-day-returning': 'app',
    'app-14-day-main': 'app',
    'app-14-day-web-main': 'app',
    'app-14-day-ft-web': 'app',
    'app-upsell': 'app',
    'email-main': 'email',
    'email-winback': 'email',
    'app-email': 'email',
    'hm-email': 'email',
    _direct: 'organic',
    _baseline: 'organic',
    'aff-ntrl': 'affiliate',
    'aff-ntrl-prm': 'affiliate',
    'affiliate-trial-npb': 'affiliate',
    referrals: 'referral',
    supporters: 'referral',
};
const CONTEXT_TYPE_MAP = {
    landing: 'landing',
    'main-survey': 'main_survey',
    'payment-results': 'payment_results',
    'payment-checkout': 'payment_checkout',
    'referrals-survey': 'referrals_survey',
    'fast-forward': 'fast_forward',
    'in-app-fast-forward': 'fast_forward',
    'noom-premium': 'noom_premium',
    'noom-summit': 'noom_summit',
    enrollment: 'enrollment',
    payment: 'payment_survey',
    'payment-survey': 'payment_survey',
    'payment-survey-referrals': 'payment_survey',
    'payment-survey-supporters': 'payment_survey',
    'payment-survey-employer': 'payment_survey',
    'payment-survey-nm-bundle': 'payment_survey',
    telehealth: 'telehealth',
    'telehealth-followup': 'telehealth',
    offers: 'offers',
    'in-app-offers': 'offers',
    'offers-consultation-survey': 'offers',
    addons: 'offers',
    'addons-cancel': 'offers',
    'counter-offer': 'counter_offer',
    'hm-counter-offer': 'hm_counter_offer',
};
const SOCIAL_ROUTE_PATTERN = /^social-.+/i;
const getTrafficType = (routeId) => {
    if (!routeId) {
        return;
    }
    if (SOCIAL_ROUTE_PATTERN.test(routeId)) {
        // social routes map to referrals
        return 'referral';
    }
    return ROUTE_ID_TRAFFIC_TYPE_MAP[routeId] || 'other';
};
exports.getTrafficType = getTrafficType;
const getContextType = (contextType) => {
    if (!contextType) {
        return;
    }
    return CONTEXT_TYPE_MAP[contextType] || 'other';
};
exports.getContextType = getContextType;
//# sourceMappingURL=routeMappings.js.map